import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import './Calculator.scss';
import './Calculator-media.scss';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import Input from '../Input/Input';
import Button from '../Button/Button';
import { InputChanged } from './functions';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { Props } from './interfaces';
import ErrorText from '../ErrorText/ErrorText';
import { ISelectItem } from '../SelectsCity/interfaces';
import { MediaContent } from '../../services/GlobalFunctions';
import Title from '../Title/Title';
import {text} from "stream/consumers";
import {content} from "../../services/content";

const Calculator = ({ buttonOnClick, setCityFrom, setCityIn, calculatorLoaded, alertLoaded, isLoading }: Props) => {
  const [selectTownFrom, setSelectTownFrom] = useState<ISelectItem>(content.calculator.optionsFrom[0]);
  const [townFrom, setTownFrom] = useState<number>(0);
  const [townto, setTownto] = useState('');

  const [weight, setWeight] = useState('');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');

  const [inshprice, setInshprice] = useState('');
  const [price, setPrice] = useState('');

  const [serverText, setServerText] = useState<string | null>(null);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const GetTariff = (e: any) => {
    e.preventDefault();

    const data = {
      data: { townFrom, townto, weight, length, width, height, inshprice, price },
      calculatorLoaded,
      alertLoaded,
      setServerText,
    };
    if (townFrom === 1) {
      ServiceData.getTariffSpb(data);
    } else {
      ServiceData.getTariffMsc(data);
    }

    buttonOnClick();
    setCityFrom(selectTownFrom.label);
    setCityIn(townto);
  };

  const SelectedTownFrom = (selectedOpt: any) => {
    setSelectTownFrom(selectedOpt);
    setTownFrom(selectedOpt.value);
  };

  const validate = ()  => {
    const errors: string[] = [];
    const maxWeight = 10000;
    if (Number(weight) > maxWeight) {
      errors.push(`Указанная масса превышает допустимую.<br/>Максимальный вес заказа не должен превышать ${maxWeight} кг.`)
    }
    const l = Number(length);
    const w = Number(width);
    const h = Number(height);

    const maxSize = 1000;
    const maxSum = 1000;
    if (l + w + h > maxSum || l > maxSize || w > maxSize || h > maxSize) {
      errors.push(`Указанные габариты превышают допустимые.<br/>Сумма длин всех сторон не должна превышать ${maxSum} см, а одна сторона не более ${maxSize} см`);
    }
    setValidationErrors(errors);
  }

  useEffect(() => {
    validate();
  }, [weight, length, width, height]);

  return (
    <div className="calculator">
      <form className="calculator__form" onSubmit={GetTariff}>
        <div className="calculator__grid-2">
          <div>
            <p className="input__label" style={{ marginTop: '20px' }}>
              {content.calculator.textFrom}
            </p>
            <Select
              options={content.calculator.optionsFrom}
              placeholder={''}
              isSearchable={false}
              className="select-input"
              classNamePrefix="select-input"
              onChange={SelectedTownFrom}
              value={selectTownFrom}
            />
          </div>

          <Input
            label={content.calculator.textFields.in.label}
            placeholder={content.calculator.textFields.in.placeholder}
            name="in"
            value={townto}
            onChange={(e: any) => setTownto(e.target.value)}
            marginTop={20}
          />
        </div>

        <div className="calculator__dimensions">
          <Input
            label={content.calculator.textFields.weight.label}
            placeholder={content.calculator.textFields.weight.placeholder}
            name="weight"
            value={weight}
            onChange={InputChanged(setWeight)}
          />
          <span></span>
          {MediaContent(
            <Input
              label={content.calculator.textFields.length.label}
              placeholder={content.calculator.textFields.length.placeholder}
              name="length"
              value={length}
              onChange={InputChanged(setLength)}
            />,
            <>
              <p className="input__label">{content.calculator.textFields.length.label}</p>
              <Input placeholder="10" name="length" value={length} onChange={InputChanged(setLength)} />
            </>
          )}
          <span className="calculator__close"></span>
          <Input name="width" placeholder="10" value={width} onChange={InputChanged(setWidth)} />
          <span className="calculator__close"></span>
          <Input name="height" placeholder="10" value={height} onChange={InputChanged(setHeight)} />
        </div>

        <div className="calculator__grid-2">
          <Input
            label={content.calculator.textFields.inshprice.label}
            placeholder={content.calculator.textFields.inshprice.placeholder}
            name="inshprice"
            value={inshprice}
            onChange={InputChanged(setInshprice)}
          />
          <Input
            label={content.calculator.textFields.price.label}
            placeholder={content.calculator.textFields.price.placeholder}
            name="price"
            value={price}
            onChange={InputChanged(setPrice)}
          />
        </div>

        {validationErrors.length > 0 ? <div className="validation-errors">
          {validationErrors.map(error => <p dangerouslySetInnerHTML={{__html: error}}></p>)}
        </div> : null}

        <div className="calculator__button">
          {serverText ? ErrorText(serverText) : null}
          <Button text={content.calculator.textButton} size="M" widthAll disabled={townto === '' || validationErrors.length > 0} loading={isLoading} />
        </div>
      </form>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Calculator));
